function galleryTest() {
  if (document.body.classList.contains('template-lifestyle-b')) {
    const elems = document.querySelectorAll('.product--thumbnail_slider');
    elems.forEach(el => {
      el.classList.remove('product--thumbnail_slider');
      el.classList.add('product--stacked');
    });
    console.log(`${elems.length} updated`);
  } else {
    console.log('The class "template-lifestyle-b" doesnt exist');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  galleryTest();
  setTimeout(galleryTest, 500);
});

window.addEventListener('load', galleryTest);
